"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var WBirthday = /** @class */ (function (_super) {
    __extends(WBirthday, _super);
    function WBirthday(props) {
        var _this = _super.call(this, props) || this;
        var states = form_store_1.default.getState();
        _this.state = {
            wbirthday_year: {
                data: states.data.wbirthday_year,
                error: states.error.wbirthday_year
            },
            wbirthday_month: {
                data: states.data.wbirthday_month,
                error: states.error.wbirthday_month
            },
            wbirthday_date: {
                data: states.data.wbirthday_date,
                error: states.error.wbirthday_date
            }
        };
        form_store_1.default.on('STATE_CHANGE', function () {
            states = form_store_1.default.getState();
            _this.setState({
                wbirthday_year: {
                    data: states.data.wbirthday_year,
                    error: states.error.wbirthday_year
                },
                wbirthday_month: {
                    data: states.data.wbirthday_month,
                    error: states.error.wbirthday_month
                },
                wbirthday_date: {
                    data: states.data.wbirthday_date,
                    error: states.error.wbirthday_date
                },
            });
        });
        return _this;
    }
    WBirthday.prototype.render = function () {
        var errors = [], errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        // Errorオブジェクトの整理
        for (var _i = 0, _a = Object.keys(this.state); _i < _a.length; _i++) {
            var field = _a[_i];
            var error = this.state[field].error;
            if (error.length > 0) {
                errors = errors.concat(this.state[field].error);
            }
        }
        ;
        // Error出力
        if (errors.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, errors[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("div", { className: "input-date" },
                react_1.default.createElement("div", { className: "input-date__box" },
                    react_1.default.createElement("input", { className: "input-text input-date__year", title: "\u59BB\u306E\u751F\u307E\u308C\u305F\u5E74\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "text", name: "wbirthday_year", defaultValue: this.state.wbirthday_year.data, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                    react_1.default.createElement("span", { className: "input-date__sep" }, "\u5E74")),
                react_1.default.createElement("div", { className: "input-date__box" },
                    react_1.default.createElement("input", { className: "input-text input-date__short", title: "\u59BB\u306E\u751F\u307E\u308C\u305F\u6708\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "text", name: "wbirthday_month", defaultValue: this.state.wbirthday_month.data, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                    react_1.default.createElement("span", { className: "input-date__sep" }, "\u6708")),
                react_1.default.createElement("div", { className: "input-date__box" },
                    react_1.default.createElement("input", { className: "input-text input-date__short", title: "\u59BB\u306E\u751F\u307E\u308C\u305F\u65E5\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "text", name: "wbirthday_date", defaultValue: this.state.wbirthday_date.data, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                    react_1.default.createElement("span", { className: "input-date__sep" }, "\u65E5")))));
    };
    return WBirthday;
}(react_1.Component));
exports.default = WBirthday;
